<template>
  <BaseMenu v-if="menu.length" :with-offset="false">
    <BaseButton size="none" theme="white" class="!p-1 w-7 h-7">
      <BaseIcon name="outline_dots_horizontal" />
    </BaseButton>

    <template #menu>
      <div class="rounded-xl w-36 bg-white shadow-lg py-2">
        <BaseButton
          v-for="menuItem in menu"
          :key="menuItem.text"
          theme="white"
          size="sm"
          class="w-full !text-gray-900"
          rounded="none"
          justify="start"
          :disabled="isProcessing"
          @click="menuItem.action"
        >
          <BaseIcon
            :name="menuItem.icon"
            class="flex-shrink-0 mr-3"
            size="xs"
          />
          {{ menuItem.text }}
        </BaseButton>
      </div>
    </template>
  </BaseMenu>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
interface MenuItem {
  icon: string
  text: string
  action: () => void
}
const { t } = useI18n()
const props = defineProps({
  isEditable: {
    type: Boolean,
    default: false,
  },
  isOwner: {
    type: Boolean,
    default: false,
  },
  isAuth: {
    type: Boolean,
    default: false,
  },
  isProcessing: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['edit', 'delete', 'report'])
const menu = computed(() => {
  const menu: MenuItem[] = []

  if (!props.isAuth) {
    return menu
  }

  // if (!props.isOwner) {
  //   menu.push({
  //     icon: 'outline_exclamation',
  //     text: t('comments.report'),
  //     action: () => emits('report'),
  //   })
  // }

  if (props.isEditable && props.isOwner) {
    menu.push({
      icon: 'outline_pencil',
      text: t('comments.edit'),
      action: () => emits('edit'),
    })
  }

  if (props.isOwner) {
    menu.push({
      icon: 'outline_trash',
      text: t('comments.delete'),
      action: () => emits('delete'),
    })
  }
  return menu
})
</script>
